import { createActions, createReducer } from "reduxsauce";

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    setOrderSampleList: [],
    setOrderSampleFilter: [],
    cleanOrderSampleList: [],
    setOrderSampleLoading: [],
    setSelectedOrderSample: [],
    unsetSelectedOrderSample: [],
    setFetchedOrderSampleDetails: [],
    setGetOrderSample: [],
    setOrderSampleToast: [],
    setOrderSampleRedirect: []
});
 
/**
 * Handlers
 */
const INITIAL_STATE = {
    orderSampleList: [],
    isLoading: false,
	listHasMore: true,
	listPage: 0,
    filter: {
        cnpj: '',
		email: '',
		nomeFantasia: '',
		razaoSocial: '',
	},
    selectedOrderSample: {
        id: null,
        data: {}
    },
    orderSampleToast: {
        showToast: false,
        message: '',
        messageType: 'toast-success'
    },
    fetchedOrderSampleDetails: {},
    getOrderSample: null,
    orderSampleRedirect: false
};
 
const setOrderSampleList = (state = INITIAL_STATE, action) => {
    return { 
        ...state, 
        orderSampleList: state.orderSampleList.concat(action.payload.list),
        listHasMore: action.payload.hasMore,
        listPage: action.payload.page
    };
}

const setOrderSampleFilter = (state = INITIAL_STATE, action) => {
    return { ...state, filter: action.payload };
}

const cleanOrderSampleList = (state = INITIAL_STATE, action) => {
    return { ...state, orderSampleList: [], orderSampleToast: INITIAL_STATE.orderSampleToast };
}

const setOrderSampleLoading = (state = INITIAL_STATE, action) => {
    return { ...state, isLoading: action.payload };
}

const setSelectedOrderSample = (state = INITIAL_STATE, action) => {
    return { ...state, selectedOrderSample: action.payload };
}

const unsetSelectedOrderSample = (state = INITIAL_STATE, action) => {
    return { ...state, selectedOrderSample: action.payload };
}

const setFetchedOrderSampleDetails = (state = INITIAL_STATE, action) => {
    return { ...state, fetchedOrderSampleDetails: action.payload };
}

const setGetOrderSample = (state = INITIAL_STATE, action) => {
    return { ...state, getOrderSample: action.payload };
}

const setOrderSampleToast = (state = INITIAL_STATE, action) => {
    return {
        ...state, 
        orderSampleToast: {
            showToast: action.payload.showToast,
            message: action.payload.message,
            messageType: action.payload.messageType
        }
    };
}

const setOrderSampleRedirect = (state = INITIAL_STATE, action) => {
    return {
        ...state, 
        orderSampleRedirect: action.payload.redirect,
        orderSampleToast: {
            showToast: action.payload.showToast,
            message: action.payload.message,
            messageType: action.payload.messageType
        }
    }
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.SET_ORDER_SAMPLE_LIST]: setOrderSampleList,
    [Types.SET_ORDER_SAMPLE_FILTER]: setOrderSampleFilter,
    [Types.CLEAN_ORDER_SAMPLE_LIST]: cleanOrderSampleList,
    [Types.SET_ORDER_SAMPLE_LOADING]: setOrderSampleLoading,
    [Types.SET_SELECTED_ORDER_SAMPLE]: setSelectedOrderSample,
    [Types.UNSET_SELECTED_ORDER_SAMPLE]: unsetSelectedOrderSample,
    [Types.SET_FETCHED_ORDER_SAMPLE_DETAILS]: setFetchedOrderSampleDetails,
    [Types.SET_GET_ORDER_SAMPLE]: setGetOrderSample,
    [Types.SET_ORDER_SAMPLE_TOAST]: setOrderSampleToast,
    [Types.SET_ORDER_SAMPLE_REDIRECT]: setOrderSampleRedirect,
});
 